export default {
  methods: {
    nextPlay (orderNum) {
      const listLen = this.groupList.length;
      if (orderNum === listLen) {
        this.$message.error('当前知识点已经是最后一个了！');
      } else {
        orderNum++;
        const item = this.groupList.filter(item => item.orderNum === orderNum);
        this.playRsc(item[ 0 ]);
      }
    },
    prevPlay (orderNum) {
      if (orderNum === 1) {
        this.$message.error('当前知识点已经是第一个了！');
      } else {
        orderNum--;
        const item = this.groupList.filter(item => item.orderNum === orderNum);
        this.playRsc(item[ 0 ]);
      }
    },
    finishPlay (orderNum) {
      this.nextPlay(orderNum);
    }
  }
};
